import React from 'react';
import PropTypes from 'prop-types';
import ContentItem from './ContentItem';
import Carousel from '../../../../core/layout/Carousel';
import Async from '../../../../core/layout/Async';
import DialogueItems from './DialogueItems';
import { groupBy, values } from 'lodash';

const dialogueItemTypes = ['DIALOGUE', 'DIALOGUE_OPTION'];

const ContentItemList = (props) => {
  let defaultItems = props.items.filter((item) => !dialogueItemTypes.find((type) => type === item.type.key));
  defaultItems = values(groupBy(defaultItems, 'order'));
  const dialogueItems = props.items.filter((item) => dialogueItemTypes.find((type) => type === item.type.key));

  return (
    <Async fetching={props.fetching}>
      <Carousel>
        {defaultItems.map((items) => (
          <ContentItem key={items[0].id} items={items} />
        ))}
        {dialogueItems.length && <DialogueItems items={dialogueItems} />}
      </Carousel>
    </Async>
  );
};

ContentItemList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
};

export default ContentItemList;
